import React from 'react';

const LKButton = ({ history }) => (
  <div className="header-user__lk" onClick={() => history.push('/lk')}>Личный кабинет</div>
);

export default LKButton;
